// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[24].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../styles/globals.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import all styles from the new component-based organization */

/* Trail Discovery animation and transition styles */
.content-transition {
  transition: opacity 0.3s ease-in-out;
}

.map-container {
  transition: height 0.3s ease-in-out;
}

.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.no-flicker {
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-font-smoothing: antialiased;
}
`, "",{"version":3,"sources":["webpack://./src/app/globals.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAGhE,oDAAoD;AACpD;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;AACrC","sourcesContent":["/* Import all styles from the new component-based organization */\n@import '../styles/globals.css';\n\n/* Trail Discovery animation and transition styles */\n.content-transition {\n  transition: opacity 0.3s ease-in-out;\n}\n\n.map-container {\n  transition: height 0.3s ease-in-out;\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.no-flicker {\n  backface-visibility: hidden;\n  transform: translateZ(0);\n  -webkit-font-smoothing: antialiased;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
